import { useStyleFilter } from '@/pages/Home/Generator/hooks/useStyleFilter';
import { FilterGroup, SfListItem } from '@/service/type/Filter';
import { useStyleFilterStore } from '@/state/style-filter-list-store';
import { useEffect, useState } from 'react';

export const useBuyStyleFilter = (filterGroup: FilterGroup) => {
  const { selectedFiltersState, updateFilterSelection } = useStyleFilterStore();

  const initialSelectedValue = filterGroup.id ? (selectedFiltersState[filterGroup.id]?.value ?? 0) : 0;

  const [selectedValue, setSelectedValue] = useState<number>(initialSelectedValue);
  const [selectedFilter, setSelectedFilter] = useState<SfListItem | undefined>(undefined);

  const handleSwitch = (data: { value: number; id: number | undefined }) => {
    setSelectedValue(data.value);

    if (filterGroup.id) {
      updateFilterSelection(filterGroup.id, data);
    }

    if (data.value === 0) {
      setSelectedFilter(filterGroup.sf_list.find((item) => item.key === 'low'));
    }
    if (data.value === 1) {
      setSelectedFilter(filterGroup.sf_list.find((item) => item.key === 'high'));
    }
  };

  const { postStyleFilterOrderRun } = useStyleFilter();

  const handleBuy = () => {
    if (selectedFilter?.id) {
      postStyleFilterOrderRun({
        orders: [{ id: selectedFilter?.id }],
      });
    }
  };

  useEffect(() => {
    if (filterGroup.sf_list?.length > 0) {
      // 如果全局状态中存在该过滤器的选择，则使用全局状态
      if (filterGroup.id && selectedFiltersState[filterGroup.id]) {
        const stateValue = selectedFiltersState[filterGroup.id].value;
        setSelectedValue(stateValue);

        if (stateValue === 0) {
          setSelectedFilter(filterGroup.sf_list.find((item) => item?.key === 'low'));
        } else if (stateValue === 1) {
          setSelectedFilter(filterGroup.sf_list.find((item) => item?.key === 'high'));
        }
      } else {
        // 否则使用默认值
        setSelectedFilter(filterGroup.sf_list[0]);

        // 更新全局状态
        if (filterGroup.id) {
          updateFilterSelection(filterGroup.id, {
            value: filterGroup.sf_list[0]?.key === 'high' ? 1 : 0,
            id: filterGroup.sf_list[0]?.id,
          });
        }
      }
    }
  }, [filterGroup, selectedFiltersState, updateFilterSelection]);

  return { selectedValue, selectedFilter, handleSwitch, handleBuy };
};
